import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import { SxProps } from '@mui/material';
import Button from '@qlub-dev/qlub-kit/dist/components/Button';
import classNames from 'classnames';
import { useQlubRouter } from '../../hook/router';
import { EnableEnum } from '../../repository/vendor';
import { useConfigContext } from '../../context/config';
import { onPushEvent } from '../../lib/gtm';
import { useLanguageSwitcherEvents } from './hooks/useLanguageSwitcherEvents';

import styles from './index.module.scss';

export interface LanguageSwitcherProps {
    drawerTitle?: string;
    containerOverride?: SxProps;
    languageSwitcherV2?: boolean;
    variant?: 'default' | 'no-flag';
}

const LanguageSwitcher = ({ languageSwitcherV2 }: LanguageSwitcherProps) => {
    const { url, lang, source } = useQlubRouter();
    const { config: countryConfig } = useConfigContext();

    const { dispatchDrawerState } = useLanguageSwitcherEvents();

    const isLanguageSwitcherUIv2 =
        languageSwitcherV2 !== undefined
            ? languageSwitcherV2
            : countryConfig?.languageSwitcherUIv2 === EnableEnum.Enable;

    const onLanguageSwitcherClicked = () => {
        onPushEvent('intent_to_change_language', {
            restaurant_name: url.slug,
            source,
        });
    };

    const onOpen = () => {
        dispatchDrawerState(true);
        if (onLanguageSwitcherClicked) {
            onLanguageSwitcherClicked();
        }
    };

    return (
        <Button
            data-qa-id="language"
            variant="text"
            onClick={onOpen}
            className={classNames(styles.button, {
                [styles.languageSwitcherV2Button]: isLanguageSwitcherUIv2,
            })}
        >
            <LanguageRoundedIcon />
            {isLanguageSwitcherUIv2 ? lang?.toLocaleUpperCase() : lang}
        </Button>
    );
};
export default LanguageSwitcher;
